import { render, staticRenderFns } from "./SimsInfo.vue?vue&type=template&id=300bc86c&"
import script from "./SimsInfo.vue?vue&type=script&lang=ts&"
export * from "./SimsInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports